import { useCommon } from '@/core/useCommon'
import ChevronRightIcon from '../assets/chevron-right.svg'

type Props = {
  // 標題
  title?: string
  // 右側元素
  children?: React.ReactNode
  // 自訂返回事件，預設回上一頁
  onBack?: () => void
}

// 二級目錄頁面 Header
const PageHeader = ({ title, children, onBack }: Props) => {
  const { goBack, t } = useCommon()

  return (
    <div className="sm:max-w-container relative flex min-h-48 w-full items-center border-b border-[#EBEBEB] bg-white px-12 sm:mx-auto sm:flex-wrap sm:py-8">
      <div className="flex w-full items-center">
        {/* 位置 */}
        <div className="hidden sm:flex sm:shrink-0 sm:items-center">
          <span className="text-16 text-[#606266]">{t('P864')}</span>
          <span className="ml-8 size-16">
            <ChevronRightIcon className="size-16 text-[#C0C4CC]" />
          </span>
        </div>

        {/* 標題 */}
        <div className="sm:text-16 flex w-full items-center justify-center px-40 sm:justify-start sm:px-8">{title}</div>
      </div>

      {/* 返回 */}
      <div
        className="sm:rounded-8 hover absolute top-1/2 left-12 -translate-y-1/2 cursor-pointer hover:opacity-90 sm:static sm:mt-12 sm:mb-8 sm:flex sm:translate-0 sm:bg-[#0050C8] sm:py-4 sm:pr-8 sm:pl-4 sm:text-white"
        onClick={onBack ?? goBack}>
        <ChevronRightIcon className="size-20 rotate-180 text-[#0D2245] sm:text-white" />
        <div className="sm:text-16 hidden sm:flex sm:leading-22">{t('P276')}</div>
      </div>
      {children}
    </div>
  )
}

export default PageHeader
